import chat from "@gromia/components/svg/icon-chat.svg";
import email from "@gromia/components/svg/icon-email.svg";
import phone from "@gromia/components/svg/icon-phone.svg";
import * as s from "@gromia/components/theme/t.module.css";
import { replicateSeparator } from "@gromia/utils";
import { useMedia } from "@gromia/utils/useMedia";
import cx from "classnames";
import { flatten, zip } from "fp-ts/lib/Array";
import { pipe } from "fp-ts/lib/function";
import * as O from "fp-ts/lib/Option";
import React from "react";

type ContactProps = {
  t: "phone" | "email" | "chat";
  title: NonNullable<React.ReactNode>;
  text: NonNullable<React.ReactNode>;
  href?: string;
};

const icons = {
  phone,
  email,
  chat,
};

const Sep = () => {
  const media = useMedia();
  return (
    <div
      style={{ width: media.sm ? 2 : 130, height: media.sm ? 130 : 2 }}
      className={cx(s.bgLight2, s.mt4, s.mb4)}
    />
  );
};

type Props = {
  children: NonNullable<React.ReactNode>;
};

export const Contacts = (props: Props) => {
  const children = React.Children.toArray(props.children);
  const separators = replicateSeparator(children.length, Sep);

  return (
    <div className={cx(s.bgWhite)} data-track="prefooter-contacts">
      <div
        className={cx(
          s.mAuto,
          children.length > 2 ? s.container : s.maxWidth680,
          s.dFlex,
          s.justifyContentBetween,
          s.alignItemsCenter,
          s.flexColumn,
          s.flexMdRow,
          s.pt5,
          s.pb5,
        )}
      >
        {flatten(zip(children, separators))}
      </div>
    </div>
  );
};

export const Contact = (props: ContactProps) => (
  <div className={cx(s.textCenter)}>
    <img src={icons[props.t]} alt={props.t} className={s.mb3} />
    <p className={cx(s.textDark, s.fontWeightBold, s.mb1)}>{props.title}</p>
    <p className={s.mb0}>
      {pipe(
        O.fromNullable(props.href),
        O.fold(
          () =>
            props.text,
          href => (
            <a
              {...(props.t === "phone"
                ? {}
                : { target: "_blank", rel: "noopener" })}
              href={href}
            >
              {props.text}
            </a>
          ),
        ),
      )}
    </p>
  </div>
);
